import {SureFlowRatingUnit} from './sure-flow-rating-unit';

export class SureFlowUnitData {

  id!: number;
  coolingTargetTotalLoad!: number;
  coolingTargetSensibleLoad!: number;
  coolingTargetLatentLoad!: number;
  coolingFluidFlowRate!: number;
  heatingTargetTotalLoad!: number;
  heatingFluidFlowRate!: number;
  sureFlowRatingUnit!: SureFlowRatingUnit;
  active!: boolean;
  userTag!: string;
  coolingEnteringFluidTemperature!: number;
  heatingEnteringFluidTemperature!: number;

}
